import {customThemeConstants} from '@hconnect/uikit/src/lib2/theme/designTokens'
import {DetailsCard, CardHeader, Icon, Button} from '@hm/fundamental'
import {mdiClose} from '@mdi/js'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {useLayoutStyles} from '../styles'
import {JobsToBeDoneInsightDetails, JobsToBeDoneTaskWithContext, ViewMode} from '../types'

import {JtbdDetails} from './JtbdDetails'
import {JtbdInsightDetailView} from './JtbdInsightDetailView'
import {JtbdInsightForm} from './JtbdInsightForm'

interface Props {
  viewMode: ViewMode
  plantUpmId: string
  selectedItem?: JobsToBeDoneTaskWithContext
  selectedInsight?: JobsToBeDoneInsightDetails
  details?: JobsToBeDoneTaskWithContext
  onCancel: () => void
  timezone: string
  setViewMode: (mode: ViewMode) => void
  onInsightClick: (insight: JobsToBeDoneInsightDetails) => void
  isEditAllowed: boolean
  insightQueryParams?: {fromDate?: string; toDate?: string}
}

export const SideCard: React.FC<Props> = ({
  viewMode,
  plantUpmId,
  selectedItem,
  selectedInsight,
  details,
  onCancel,
  setViewMode,
  onInsightClick,
  timezone,
  isEditAllowed,
  insightQueryParams
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {classes} = useLayoutStyles()

  const handleBackToTimeline = () => {
    if (setViewMode) {
      setViewMode(ViewMode.detailsMode)
    }
  }

  const handleEditInsight = () => {
    if (setViewMode) {
      setViewMode(ViewMode.editMode)
    }
  }

  switch (viewMode) {
    case ViewMode.createMode:
      return (
        <DetailsCard>
          <CardHeader
            containerClassname={classes.sideCardHeader}
            aside={
              <Button onClick={onCancel} variant="tertiary">
                <Icon
                  path={mdiClose}
                  size="regular"
                  color={customThemeConstants().palette.barChartDefault}
                />
              </Button>
            }
          >
            {t('jobsToBeDone.form.title')}
          </CardHeader>
          {selectedItem && (
            <JtbdInsightForm plantUpmId={plantUpmId} task={selectedItem} onCancel={onCancel} />
          )}
          {details && (
            <JtbdInsightForm plantUpmId={plantUpmId} task={details} onCancel={onCancel} />
          )}
        </DetailsCard>
      )

    case ViewMode.detailsMode:
      return selectedItem ? (
        <JtbdDetails
          onCancel={onCancel}
          plantUpmId={plantUpmId}
          task={selectedItem}
          timezone={timezone}
          onAddInsightClick={() => setViewMode(ViewMode.createMode)}
          onInsightClick={onInsightClick}
          isEditAllowed={isEditAllowed}
          insightQueryParams={insightQueryParams}
        />
      ) : null

    case ViewMode.insightDetailMode:
      return selectedInsight && selectedItem ? (
        <JtbdInsightDetailView
          insight={selectedInsight}
          timezone={timezone}
          onBack={handleBackToTimeline}
          onClose={onCancel}
          onEdit={handleEditInsight}
          isEditAllowed={isEditAllowed}
        />
      ) : null

    case ViewMode.editMode:
      return selectedInsight && selectedItem ? (
        <DetailsCard>
          <CardHeader
            containerClassname={classes.sideCardHeader}
            aside={
              <Button onClick={onCancel} variant="tertiary">
                <Icon
                  path={mdiClose}
                  size="regular"
                  color={customThemeConstants().palette.barChartDefault}
                />
              </Button>
            }
          >
            {t('jobsToBeDone.form.editTitle')}
          </CardHeader>
          <JtbdInsightForm
            plantUpmId={plantUpmId}
            task={selectedItem}
            existingInsight={selectedInsight}
            onCancel={onCancel}
          />
        </DetailsCard>
      ) : null

    case ViewMode.tablesOnlyMode:
    default:
      return null
  }
}
